<template>
    <div v-if="quota">
        <b-modal
            v-model="show_modal_local"
            :title="'Квота'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <div class="row">
                <div class="col col-12">
                    <b-form-group>
                        <label>Тип квоты</label>
                        <b-form-select id="quotaTypeSelect"
                               :plain="true"
                               v-model="quota.type"
                               :options="quotaTypes"
                               value-field="id"
                               text-field="title"
                        >
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row" v-if="!!quota.type">
                <div class="col col-12">
                    <b-form-group label="Бронь"
                    >
                        <div class="input-group">
                            <input class="form-control"
                                   v-model="quota.booking_id"
                                   :readonly="true"
                                   :disabled="true"
                            />
                            <button class="btn btn-primary">
                                Выбрать
                            </button>
                        </div>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        :invalid-feedback="veeErrors.first('roomSeleсt')"
                        :state="validateState('roomSeleсt')"
                        label="Номер"
                    >
                        <b-form-select
                            id="roomSeleсt"
                            :plain="true"
                            v-model="quota.room_id"
                            :options="hotel.rooms"
                            :state="validateState('roomSeleсt')"
                            value-field="id"
                            text-field="title"
                            placeholder="Выберите номер"
                            required
                            v-validate="{required:true,integer:true}"
                            data-vv-as="Номер"
                            data-vv-name="roomSeleсt"
                            :readonly="!!quota.type"
                            :disabled="!!quota.type"
                        ></b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-6">
                    <b-form-group label="начало действия квоты">
                        <v-date-picker
                            v-model='_period_start'
                            id="period_start"
                            name="period_start"
                            data-vv-as="'начало периода'"
                            :state="validateState('period_start')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="period_start_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
                <div class="col col-6">
                    <b-form-group label="окончание действия квоты">
                        <v-date-picker
                            v-model='_period_end'
                            id="period_end"
                            name="period_end"
                            data-vv-as="'окончание периода'"
                            :state="validateState('period_end')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="period_end_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-6">
                    <b-form-group
                        :invalid-feedback="veeErrors.first('quotaValue')"
                        label="Квота"
                    >
                        <input class="form-control"
                               v-model="quota.rooms_count"
                               v-validate="{required:true,integer:true,max_value:33000000,min_value:0}"
                               data-vv-as="квота"
                               data-vv-name="quotaValue"
                               :readonly="!!quota.type"
                               :disabled="!!quota.type"
                        />
                    </b-form-group>
                </div>

                <div class="col col-6" v-if="!quota.type">
                    <b-form-group
                        :invalid-feedback="veeErrors.first('redemption_days')"
                        label="Дней до заезда"
                    >
                        <input class="form-control"
                               v-model="quota.redemption_days"
                               v-validate="{required:true,integer:true,max_value:100,min_value:1}"
                               data-vv-as="дней до заезда"
                               data-vv-name="redemption_days"
                               :readonly="!!quota.type"
                               :disabled="!!quota.type"
                        />
                    </b-form-group>
                </div>


                <div class="col col-6"  v-if="!!quota.type">
                    <b-form-group
                        :invalid-feedback="veeErrors.first('redemption_date')"
                        :state="validateState('redemption_date')"
                        label="Крайняя дата выкупа квоты"
                    >
                        <v-date-picker
                            id="redemption_date"
                            v-model='quota.redemption_date'
                            :required="true"
                            v-validate="{required:true}"
                            data-vv-as="Крайняя дата выкупа квоты"
                            data-vv-name="redemption_date"
                            :state="validateState('redemption_date')"
                        ></v-date-picker>
                    </b-form-group>
                </div>

            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        :invalid-feedback="veeErrors.first('quotaComment')"
                        label="Комментарий"
                    >
                        <input
                            class="form-control"
                            v-model="quota.comment"
                            v-validate="{max:100}"
                            data-vv-as="комментарий"
                            data-vv-name="quotaComment"
                        />
                    </b-form-group>
                </div>
            </div>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_quota } from '@/functions_quota';
    import { functions_room } from '@/functions_room';
    import ImagesUpload from '@/components/ImagesUpload'

    export default {
        name: 'QuotaEditDialog',
        mixins: [functions, functions_quota, functions_room],

        data: function () {
            return {
                quotaTypes: [
                    { 'id':0, title:'мягкая квота' },
                    { 'id':1, title:'невыкупленная бронь' },
                ]
            };
        },
        model: {
            prop: "quota_id",
            event: "hide"
        },
        props: {
            quota_id: Number,
            hquotas_prop: Array,
            hotel_prop: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.$validator.validateAll().then((result) => {
                    if (!result) { return false; }
                    console.log('handleOk1');
                    this.saveQuota(function (self, quota) {

                        let hotelQuota = self.findElementByID(self.hquotas, self.quota.id);
                        console.log('handleOk2 hotelQuota=', hotelQuota);
                        if (self.is(hotelQuota)) {
                            hotelQuota.comment = self.quota.comment;
                            hotelQuota.begin_at = self.quota.begin_at;
                            hotelQuota.end_at = self.quota.end_at;
                            hotelQuota.rooms_count = self.quota.rooms_count;
                            hotelQuota.room_id = self.quota.room_id;
                            let r = self.findElementByID(self.hotel.rooms, self.quota.room_id);
                            if (self.is(r))  hotelQuota.room_title = r.title;
                        }
                        self.$emit("changed", self.quota.id);
                        self.$emit("hide", 0);
                    }, this);
                });
            },
        },
        computed: {
            show_modal_local: {
                get: function () {
                    return this.is(this.quota);
                },
                set: function (newValue) {}
            },

            _period_start : {
                get: function () {
                    if (!this.is(this.quota.begin_at)) return null;
                    return new Date(this.quota.begin_at.slice(0, 10));
                },
                set: function (v) {
                    this.quota.begin_at = dateToISO(v);
                }
            },

            _period_end : {
                get: function () {
                    if (!this.is(this.quota.end_at)) return null;
                    return new Date(this.quota.end_at.slice(0, 10));
                },
                set: function (v) {
                    this.quota.end_at = dateToISO(v);
                }
            },

        },
        created: function() {
            this.hquotas = this.hquotas_prop;
            this.hotel = this.hotel_prop;
            this.loadQuota(this.quota_id);
        },
        mounted: function() {
        },
        updated: function() {
        },
    }
</script>

